/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react'
import { useAlert } from 'react-alert'

import {
  contactsModel,
  documentsModel,
  AddressModel
} from '../../../domain/models'

import { maskCep, maskTel, maskTelResidential } from '../../utils'
import { InputRadio, Input, SelectInput } from '..'

import { IconTrashSvg } from '../../assets/icons/svgComponents'

import * as S from './styles'

export const DocumentsCard = ({
  index,
  defaultValue,
  onDelete,
  onChangeComponent
}: any) => {
  const [data, setData] = useState<documentsModel>()

  useEffect(() => {
    if (onChangeComponent && data) {
      onChangeComponent(data)
    }
  }, [data])

  useEffect(() => {
    if (defaultValue) {
      setData(defaultValue)
    }
  }, [defaultValue])

  return (
    <S.CardContainer>
      <S.headerCard>
        <InputRadio
          label="Principal"
          name="radioDocuments"
          labelColor="#4f4f4f"
          labelFor={`radioDocuments-${index}`}
          value={index}
          defaultChecked={defaultValue?.principal}
        />
        <button type="button" onClick={() => onDelete()}>
          <IconTrashSvg />
        </button>
      </S.headerCard>
      <S.InputsContainer grid={3}>
        <Input
          labelColor="#4F4F4F"
          label={defaultValue?.tipoDocumento?.descricao}
          name={defaultValue?.tipoDocumento?.descricao}
          type="text"
          maxLength={50}
          required
          onChange={(e: any) =>
            setData((prev: any) => ({
              ...prev,
              numero: e.target.value
            }))
          }
          defaultValue={defaultValue?.numero}
          value={data?.numero}
        />
        <Input
          labelColor="#4F4F4F"
          label="Orgão expeditor"
          name="orgao expeditor"
          type="text"
          maxLength={100}
          onChange={(e: any) =>
            setData((prev: any) => ({
              ...prev,
              orgaoExpedidor: e.target.value
            }))
          }
          defaultValue={defaultValue?.orgaoExpedidor}
          value={data?.orgaoExpedidor}
        />
        <Input
          labelColor="#4F4F4F"
          label="UF do orgão expeditor"
          name="uf do orgao expeditor"
          type="text"
          onChange={(e: any) =>
            setData((prev: any) => ({
              ...prev,
              uf: e.target.value
            }))
          }
          defaultValue={defaultValue?.uf}
          value={data?.uf}
        />
        <Input
          labelColor="#4F4F4F"
          label="Data de emissão"
          name="data de emissão"
          type="date"
          onChange={(e: any) =>
            setData((prev: any) => ({
              ...prev,
              dataEmissao: e.target.value
            }))
          }
          defaultValue={defaultValue?.dataEmissao}
          value={data?.dataEmissao}
          max={'2222-10-29'}
        />
        <Input
          labelColor="#4F4F4F"
          label="Data de vencimento"
          name="data de vencimento"
          type="date"
          onChange={(e: any) =>
            setData((prev: any) => ({
              ...prev,
              dataVencimento: e.target.value
            }))
          }
          defaultValue={defaultValue?.dataVencimento}
          value={data?.dataVencimento}
          max={'2222-10-29'}
        />
      </S.InputsContainer>
    </S.CardContainer>
  )
}

export const AddressCard = ({
  index,
  defaultValue,
  onDelete,
  onChangeComponent
}: any) => {
  const [data, setData] = useState<AddressModel>()
  const alert = useAlert()

  const checkCEP = (event: React.FocusEvent<HTMLInputElement>) => {
    const cep = event.target.value.replace(/\D/g, '')
    fetch(`https://viacep.com.br/ws/${cep}/json/`)
      .then((res) => res.json())
      .then((data) => {
        if (!data.erro) {
          setData((prev: any) => ({
            ...prev,
            logradouro: data.logradouro,
            bairro: data.bairro,
            cidade: data.localidade,
            uf: data.uf
          }))
        } else {
          alert.show('Cep invalido. Tente novamente!', {
            type: 'error',
            timeout: 4000
          })
        }
      })
  }

  useEffect(() => {
    if (onChangeComponent && data) {
      onChangeComponent(data)
    }
  }, [data])

  useEffect(() => {
    if (defaultValue) {
      setData(defaultValue)
    }
  }, [])

  return (
    <S.CardContainer>
      <S.headerCard>
        <InputRadio
          label="Principal"
          name="radioAnddress"
          labelColor="#4f4f4f"
          labelFor={`radioAnddress-${index}`}
          value={index}
          defaultChecked={defaultValue?.principal}
        />
        <button type="button" onClick={() => onDelete()}>
          <IconTrashSvg />
        </button>
      </S.headerCard>
      <S.InputsContainer grid={3}>
        <Input
          labelColor="#4F4F4F"
          label="CEP"
          name="cep"
          type="text"
          maxLength={9}
          onChange={(e: any) =>
            setData((prev: any) => ({
              ...prev,
              cep: e.target.value
            }))
          }
          defaultValue={defaultValue?.cep}
          value={maskCep(data?.cep)}
          onBlur={checkCEP}
        />
        <Input
          labelColor="#4F4F4F"
          label="Rua"
          name="street"
          type="text"
          maxLength={100}
          onChange={(e: any) =>
            setData((prev: any) => ({
              ...prev,
              logradouro: e.target.value
            }))
          }
          defaultValue={defaultValue?.logradouro}
          value={data?.logradouro}
        />
        <Input
          labelColor="#4F4F4F"
          label="Número"
          name="number"
          type="text"
          maxLength={6}
          onChange={(e: any) =>
            setData((prev: any) => ({
              ...prev,
              numero: e.target.value
            }))
          }
          defaultValue={defaultValue?.numero}
          value={data?.numero}
        />
        <Input
          labelColor="#4F4F4F"
          label="Bairro"
          name="district"
          type="text"
          maxLength={100}
          onChange={(e: any) =>
            setData((prev: any) => ({
              ...prev,
              bairro: e.target.value
            }))
          }
          defaultValue={defaultValue?.bairro}
          value={data?.bairro}
        />
        <Input
          labelColor="#4F4F4F"
          label="Complemento"
          name="complement"
          type="text"
          maxLength={100}
          onChange={(e: any) =>
            setData((prev: any) => ({
              ...prev,
              complemento: e.target.value
            }))
          }
          defaultValue={defaultValue?.complemento}
          value={data?.complemento}
        />
        <Input
          labelColor="#4F4F4F"
          label="Cidade"
          name="city"
          type="text"
          maxLength={100}
          onChange={(e: any) =>
            setData((prev: any) => ({
              ...prev,
              cidade: e.target.value
            }))
          }
          defaultValue={defaultValue?.cidade}
          value={data?.cidade}
        />
        <Input
          labelColor="#4F4F4F"
          label="Estado"
          name="state"
          type="text"
          autoComplete="off"
          onChange={(e: any) =>
            setData((prev: any) => ({
              ...prev,
              uf: e.target.value
            }))
          }
          defaultValue={defaultValue?.uf}
          value={data?.uf}
        />
      </S.InputsContainer>
    </S.CardContainer>
  )
}

export const ContactCard = ({
  index,
  defaultValue,
  onDelete,
  onChangeComponent
}: any) => {
  const [data, setData] = useState<contactsModel>()

  const typeToContact = [
    {
      label: 'Celular',
      value: 'celular'
    },
    {
      label: 'Comercial',
      value: 'comercial'
    },
    {
      label: 'Residencial',
      value: 'residencial'
    }
  ]

  useEffect(() => {
    if (onChangeComponent && data) {
      onChangeComponent(data)
    }
  }, [data])

  useEffect(() => {
    if (defaultValue) {
      setData(defaultValue)
    }
  }, [])

  return (
    <S.CardContainer>
      <S.headerCard>
        <InputRadio
          label="Principal"
          name="radioContant"
          labelColor="#4f4f4f"
          labelFor={`radioContant-${index}`}
          value={index}
          defaultChecked={defaultValue?.principal}
        />
        <button type="button" onClick={() => onDelete()}>
          <IconTrashSvg />
        </button>
      </S.headerCard>
      <S.InputsContainer grid={2}>
        <SelectInput
          labelColor="#4F4F4F"
          label="Tipo de contato"
          name="tipo de contato"
          required
          onChange={(e: any) =>
            setData((prev: any) => ({
              ...prev,
              tipo: e.target.value
            }))
          }
          defaultValue={defaultValue?.tipo}
          value={data?.tipo}
          options={typeToContact}
        />
        <Input
          labelColor="#4F4F4F"
          label="Contato"
          name="contato"
          type="text"
          required
          onChange={(e: any) =>
            setData((prev: any) => ({
              ...prev,
              contato: e.target.value
            }))
          }
          maxLength={data?.tipo === 'celular' ? 15 : 14}
          defaultValue={defaultValue?.contato}
          value={
            data?.tipo === 'celular'
              ? maskTel(data?.contato)
              : maskTelResidential(data?.contato)
          }
        />
      </S.InputsContainer>
    </S.CardContainer>
  )
}
